// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"da6ed1cc","555":"d8d967e4"}[chunkId] + ".chunk.css";
};